import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import Expenses from './pages/Expenses';
import Settings from './pages/Settings';
import Reports from './pages/Reports';
import AtmWithdrawals from './pages/AtmWithdrawals';
import LoyaltyCards from './pages/LoyaltyCards';
import Warranties from './pages/Warranties';
import ShoppingLists from './pages/ShoppingLists';
import RecurringExpenses from './pages/RecurringExpenses';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import Layout from './components/Layout';
import { Toaster } from './components/ui/sonner';
import './App.css';

// Re-export API for backward compatibility
export { API } from './api';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const user = localStorage.getItem('user');
    if (user) {
      setIsAuthenticated(true);
    }
    setLoading(false);
  }, []);

  const handleLogin = (user) => {
    localStorage.setItem('user', JSON.stringify(user));
    setIsAuthenticated(true);
  };

  const handleLogout = () => {
    localStorage.removeItem('user');
    setIsAuthenticated(false);
  };

  if (loading) {
    return <div className="flex items-center justify-center h-screen">Caricamento...</div>;
  }

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route
            path="/login"
            element={
              isAuthenticated ? (
                <Navigate to="/" />
              ) : (
                <Login onLogin={handleLogin} />
              )
            }
          />
          <Route
            path="/register"
            element={
              isAuthenticated ? (
                <Navigate to="/" />
              ) : (
                <Register onRegisterComplete={() => {}} />
              )
            }
          />
          <Route
            path="/"
            element={
              isAuthenticated ? (
                <Layout onLogout={handleLogout}>
                  <Dashboard />
                </Layout>
              ) : (
                <Navigate to="/login" />
              )
            }
          />
          <Route
            path="/spese"
            element={
              isAuthenticated ? (
                <Layout onLogout={handleLogout}>
                  <Expenses />
                </Layout>
              ) : (
                <Navigate to="/login" />
              )
            }
          />
          <Route
            path="/report"
            element={
              isAuthenticated ? (
                <Layout onLogout={handleLogout}>
                  <Reports />
                </Layout>
              ) : (
                <Navigate to="/login" />
              )
            }
          />
          <Route
            path="/impostazioni"
            element={
              isAuthenticated ? (
                <Layout onLogout={handleLogout}>
                  <Settings />
                </Layout>
              ) : (
                <Navigate to="/login" />
              )
            }
          />
          <Route
            path="/prelievi"
            element={
              isAuthenticated ? (
                <Layout onLogout={handleLogout}>
                  <AtmWithdrawals />
                </Layout>
              ) : (
                <Navigate to="/login" />
              )
            }
          />
          <Route
            path="/tessere"
            element={
              isAuthenticated ? (
                <Layout onLogout={handleLogout}>
                  <LoyaltyCards />
                </Layout>
              ) : (
                <Navigate to="/login" />
              )
            }
          />
          <Route
            path="/garanzie"
            element={
              isAuthenticated ? (
                <Layout onLogout={handleLogout}>
                  <Warranties />
                </Layout>
              ) : (
                <Navigate to="/login" />
              )
            }
          />
          <Route
            path="/lista-spesa"
            element={
              isAuthenticated ? (
                <Layout onLogout={handleLogout}>
                  <ShoppingLists />
                </Layout>
              ) : (
                <Navigate to="/login" />
              )
            }
          />
          <Route
            path="/spese-ricorrenti"
            element={
              isAuthenticated ? (
                <Layout onLogout={handleLogout}>
                  <RecurringExpenses />
                </Layout>
              ) : (
                <Navigate to="/login" />
              )
            }
          />
          {/* Admin Routes - Separate login */}
          <Route
            path="/admin"
            element={<AdminLogin />}
          />
          <Route
            path="/admin/login"
            element={<AdminLogin />}
          />
          <Route
            path="/admin/dashboard"
            element={
              isAuthenticated ? (
                <Layout onLogout={handleLogout}>
                  <AdminDashboard />
                </Layout>
              ) : (
                <Navigate to="/admin" />
              )
            }
          />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" />
    </div>
  );
}

export default App;
